import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import Loader from "../../../components/loader";

import api from "../../../services/api";

import Info from "./info";
import Raw from "./raw";

const TABS = {
  INFO: "Info",
  RAW: "Raw",
};

export default function View() {
  const [tab, setTab] = useState(TABS.INFO);
  const [meeting, setMeeting] = useState(null);

  const { id } = useParams();

  useEffect(() => {
    get();
  }, [id]);

  async function get() {
    try {
      const { data: d } = await api.get(`/meeting/${id}`);
      setMeeting(d);
    } catch (e) {
      console.log("a", e);
    }
  }

  if (!meeting) return <Loader />;

  return (
    <div>
      <div className="m-2">
        <div className="flex justify-between">
          <div>{`${meeting.name}`}</div>
        </div>
        <div className="text-sm font-medium text-center text-gray-500 border-b border-gray-200 dark:text-gray-400 dark:border-gray-700">
          <ul className="flex flex-wrap -mb-px list-none space-x-2">
            <li
              onClick={(e) => setTab(TABS.INFO)}
              className={`inline-block p-2 rounded-t-lg border-b-2 border-transparent hover:text-gray-600 cursor-pointer dark:hover:text-gray-300 ${
                tab === TABS.INFO && "border-primary"
              }`}>
              Info
            </li>
            <li
              onClick={(e) => setTab(TABS.RAW)}
              className={`inline-block p-2 rounded-t-lg border-b-2 border-transparent hover:text-gray-600 cursor-pointer dark:hover:text-gray-300 ${
                tab === TABS.RAW && "border-primary"
              }`}>
              Raw
            </li>
          </ul>
        </div>
        {tab === TABS.INFO && <Info meeting={meeting} setMeeting={setMeeting} />}
        {tab === TABS.RAW && <Raw data={meeting} />}
      </div>
    </div>
  );
};
